import axios from 'axios/index'

const namespaced = true

const state = {
  userId: null,
  userProfile: null
}
const actions = {
  getUserData ({ commit, rootState }, data) {
    return axios({
      method: 'GET',
      url: '/api/private/v3.0/companies/' + rootState.userInfo.company.id + '/users/' + rootState.userInfo.id + '/'
    })
      .then(response => {
        commit('getUserProfile', response.data)
        console.log(response)
      })
      .catch(error => {
        console.log(error)
      })
  },
  addUserData ({ commit, state, rootState }, data) {
    return axios({
      method: 'PUT',
      url: '/api/private/v3.0/companies/' + rootState.activateUser.user.company.id + '/users/' + rootState.activateUser.user.id + '/',
      data: data
    })
      .then(response => {
        console.log(response)
      })
      .catch(error => {
        console.log(error)
      })
  },
  editUserData ({ state, rootState }, data) {
    return axios({
      method: 'PATCH',
      url: '/api/private/v3.0/companies/' + rootState.userInfo.company.id + '/users/' + rootState.userInfo.id + '/',
      data: data
    })
  },
  // editAvatar ({ state }, data) {
  //   return axios({
  //     method: 'PATCH',
  //     url: '/api/private/v3.0/profiles/' + state.userId + '/',
  //     headers: {
  //       'Content-Type': 'multipart/form-data'
  //     },
  //     data: data
  //   })
  //     .then(response => {
  //       // swal('Данные изменены', '', 'success')
  //       console.log(response)
  //     })
  //     .catch(error => {
  //       swal('Ошибка', '', 'error')
  //       console.log(error)
  //     })
  // },
  // getUserData ({ commit, state }) {
  //   return axios({
  //     method: 'GET',
  //     url: '/api/private/v3.0/user/'
  //   })
  //     .then(response => {
  //       commit('getUserID', response.data[0].profile.id)
  //     })
  //     .catch(error => {
  //       console.log(error)
  //     })
  // },
  async getUserDataProfile ({ commit, state, dispatch }) {
    await dispatch('getUserData')
    return axios({
      method: 'GET',
      url: '/api/private/v3.0/user/' + state.userId + '/'
    })
      .then(response => {
        commit('getUserProfile', response.data)
      })
      .catch(error => {
        console.log(error)
      })
  },
  setPassByMobile ({ commit, state }) {
    return axios({
      method: 'POST',
      url: '/api/private/v3.0/users/set_password/'
    })
      .then(response => {
        console.log(response)
      })
      .catch(error => {
        console.log(error)
      })
  }
}
const mutations = {
  getUserID (state, data) {
    state.userId = data
    console.log(data)
  },
  getUserProfile (state, data) {
    state.userProfile = data
    console.log(data)
  }
}
const getters = {}

export default {
  namespaced,
  state,
  actions,
  mutations,
  getters
}
